import { render, staticRenderFns } from "./Comparativo.vue?vue&type=template&id=0706330b"
import script from "./Comparativo.vue?vue&type=script&lang=js"
export * from "./Comparativo.vue?vue&type=script&lang=js"
import style0 from "./Comparativo.vue?vue&type=style&index=0&id=0706330b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports